import React from 'react';
import PropTypes from 'prop-types';

import { OPEN_RECORDER_EVENT } from '../videoRequest';

// CTA under a received "Request a video" message (recipient view only); the button opens the
// composer's recorder via OPEN_RECORDER_EVENT and the normal attach flow takes over.
function VideoRequestCard({ senderFirstName }) {
  return (
    <div className="video-request-cta text-center p-3 my-2">
      <div className="fw-semibold mb-2">{senderFirstName} is requesting a video!</div>
      <button
        type="button"
        className="btn btn-sm btn-blue-purple-gradient"
        onClick={() => window.dispatchEvent(new CustomEvent(OPEN_RECORDER_EVENT))}
      >
        <i className="fa-solid fa-video me-1" aria-hidden="true" /> Record Video
      </button>
    </div>
  );
}

VideoRequestCard.propTypes = {
  senderFirstName: PropTypes.string.isRequired,
};

export default VideoRequestCard;
